import type { CSSProperties } from 'react';
import type { ViewStyle } from 'react-native';

type WebStyleProperties = Pick<
  CSSProperties,
  | 'backgroundImage'
  | 'backgroundSize'
  | 'backgroundRepeat'
  | 'backdropFilter'
  | 'wordBreak'
  | 'whiteSpace'
  | 'textOverflow'
  | 'minHeight'
  | 'width'
>;

// These browser styles are supported by our react-native-web runtime but are
// absent from React Native's platform types. Keep the bridge explicit and
// validate the CSS values instead of widening every native style definition.
export const webStyle = (style: WebStyleProperties): ViewStyle =>
  style as ViewStyle;
